var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"submit":function($event){$event.preventDefault();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }